const state = {
  data: [],
  indexByNo: {},
  needReload: false,
  param: {
    filter: {},
    sort: [{ field: 'licenseNo', order: 'DESC' }],
  },
  totalPages: 0,
  totalCount: 0,
}

const actions = {
  GET_LICENSE: ({ commit }, params) => {
    commit('MUTATION_GET_LICENSE', params);
  },
  ADD_LICENSE: ({ commit }, params) => {
    commit('MUTATION_ADD_LICENSE', params);
  },
  CHANGE_FILTER: ({ commit }, payload) => {
    commit('MUTATION_CHANGE_FILTER', payload);
  },
}

const mutations = {
  MUTATION_GET_LICENSE: (state, payload) => {
    if (payload && payload.data) {
      const { list } = payload.data;
      const { offset, limit } = payload.config.params;

      // 전체 목록 수
      const totalCount = payload.data.list.length > 0 ? payload.data.list[0].rnum + offset : 0;
      // 전체 페이지 수
      const totalPages = Math.ceil(totalCount / limit);

      state['data'] = payload.data.list[0];
      state['needReload'] = false;
      state['totalCount'] = totalCount;
      state['totalPages'] = totalPages;
    }
  },
  MUTATION_ADD_LICENSE: (state, payload) => {
    state["needReload"] = true;
  },
  MUTATION_CHANGE_FILTER: (state, payload) => {
    state["param"]["filter"] = payload;
  }
}

const getters = {
  STATE: (state) => {
    return state
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}